import React from 'react'
import Parking from '../../../../assets/img/categories/parking.jpg'
import Guide from '../../../../assets/img/categories/guide.png'
import Regulatory from '../../../../assets/img/categories/regulatory.png'
import Warning from '../../../../assets/img/categories/warning.png'
import Other from '../../../../assets/img/categories/other.png'
import '../styles/Sidebar.css'

const checkCategory = category => {
  switch (category) {
    case 'parking':
      return Parking
    case 'guide':
      return Guide
    case 'regulatory':
      return Regulatory
    case 'warning':
      return Warning
    case 'other':
      return Other
    default:
      return null
  }
}

const SidebarImage = ({ category }) => (
  <img
    src={checkCategory(category)}
    alt={`${category} Sign`}
    className="categoryImages"
  />
)

export default SidebarImage



// WEBPACK FOOTER //
// ./src/components/Elements/Sidebar/CategoryImages/Sidebar.jsx